module.exports = __webpack_public_path__ + "img/Clutch.4719d122.png";